var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search_FILL0_wght400_GRAD0_opsz48",
    d: "M19.144,19.95l-5.114-5.114a4.285,4.285,0,0,1-1.361.787,4.812,4.812,0,0,1-1.653.282,4.841,4.841,0,0,1-3.558-1.458A4.8,4.8,0,0,1,6,10.928,4.8,4.8,0,0,1,7.458,7.408,4.819,4.819,0,0,1,11,5.95a4.764,4.764,0,0,1,3.51,1.458,4.977,4.977,0,0,1,1.176,5.133A4.935,4.935,0,0,1,14.867,14L20,19.094ZM11,14.739a3.639,3.639,0,0,0,2.683-1.118,3.687,3.687,0,0,0,1.108-2.693,3.687,3.687,0,0,0-1.108-2.693A3.639,3.639,0,0,0,11,7.117a3.817,3.817,0,0,0-3.831,3.811A3.817,3.817,0,0,0,11,14.739Z",
    transform: "translate(-6 -5.95)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ba4debcff4708be17cc0558b4bbdedeb.svg";
export { ForwardRef as ReactComponent };